import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import DynamicAuctionListing from '../AuctionLots/dynamicListing'
import { useFormik } from 'formik'
import AuctionContext from '@/product/context/auction/auctionContext'
import DynamicListing from '../Listing/dynamicListing'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import CustomCommonContext from '../../custom/context/common/commonContext'
import BulkListing from '@/views/Listing/BulkListing'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

const Inventory = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const { getAllExportDownload } = useContext(ReportContext)
    const auctionContext = useContext(AuctionContext)

    const {
        project_tablefields,
        project_dynamicfields,
        propertyColumnReOrder,
    } = dynamicContext
    const { all_auctions, getAllAuctions, responseStatus, clearResponse } =
        auctionContext
    const { alldata_all_dropdown } = useContext(CustomCommonContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [dynamicFieldValues, setDynamicFieldValues] = useState([])
    const [mapArrayData, setMapArrayData] = useState([])
    const history = useHistory()
    const [custom, setCustom] = useState({})
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [auctionManage, setAuctionManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const filterElements = [
        'dimension_length',
        'dimension_width',
        'dimension_height',
        'dimension_unit',
        'weight_value',
        'weight_unit',
        'origin_zip',
        'location_id',
        'local_pickup_dates',
        'local_pickup_start_hour',
        'local_pickup_end_hour',
        'local_pickup_appt_per_slot',
        'local_pickup_slot_timeframe',
        'station_package_code',
        'station_warehouse',
    ]
    const [bulkPopup, setBulkPopup] = useState(false)
    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup && status == 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }

    const toggleAuctionPopup = (popup, status, id) => {
        if (popup && status == 'edit') {
            handleRedirectInternal(history, `auction/edit/${id}`)
        }
    }

    useEffect(() => {
        setCustom({
            market_status: {
                value: aucId !== '' || lotStatus ? [] : ['open', 'draft'],
                type: 'array',
                field: 'p.market_status',
            },
            action: {
                value: aucId !== '' ? '' : lotStatus || '',
                type: 'in',
                field: 'p.market_status',
            },
            auctionid: {
                value: aucId !== '' ? aucId : '0',
                type: 'in',
                field: 'p.auctionid',
            },
        })
    }, [lotStatus, aucId])

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            console.log(project_tablefields, 'project')
            let dynamicValueAssign = {}
            dynamicValueAssign.data = project_tablefields
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })

            dynamicValueAssign.data.push({
                label: 'Category',
                placeholder: 'Select Category',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                filter_type: 'in',
                field: 'category',
                name: 'category',
                filter: true,
                table_search: 1,
                view_page: '1',
                active: 1,
                is_default: 0,
                options: alldata_all_dropdown
                    .filter((maincat) => maincat.variable === 'category')
                    .map((maincat) => {
                        let categoryChanged = {}
                        categoryChanged.show = maincat.description
                        categoryChanged.value = maincat.id
                        return categoryChanged
                    }),
            })
            console.log(dynamicValueAssign.data, 'project')
            setSearchInfo(dynamicValueAssign)
        }
    }, [lotStatus, project_tablefields])

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            console.log(project_tablefields, 'okayyy')

            let dynamicValueAssign = [...project_tablefields]
            dynamicValueAssign.map((data) => {
                if (data.field === 'title') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })
            if (lotStatus === 'draft') {
                dynamicValueAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Missing fields',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }
            if (lotStatus != 'draft') {
                dynamicValueAssign.push({
                    field: 'bidscount',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Bid Count',
                    tableShow: 1,
                    table_search: 1,
                })
            }

            let dynamicValueAssignValue = dynamicValueAssign.filter(
                (el) => el.field !== 'buynow_project_id'
            )
            setTableValue(dynamicValueAssignValue)
        }
    }, [project_tablefields, lotStatus])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let dynamicValueAssign = project_dynamicfields
            console.log(project_dynamicfields, 'dynamicc')
            setMapArrayData(dynamicValueAssign)
            setDynamicFieldValues(dynamicValueAssign)
        }
    }, [project_dynamicfields])

    useEffect(() => {
        if (props.invId) {
            if (props.invId !== 0) {
                if (!project_tablefields.length) {
                    handleRedirectInternal(history, 'erp')
                } else {
                    console.log(props.invId, 'prop')
                    setAucId(parseInt(props.invId, 10))
                }
            }
        }
    }, [props.invID, project_tablefields])

    useEffect(() => {
        if (tableValue.length) {
            tableValue.map((data, index) => {
                if (data.field === 'id') {
                    data.disabled = true
                    data.filterField = 'p.id'
                    data.filterable = true
                }
            })
        }
    }, [tableValue])

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            having: {
                future_active: {
                    value: 0,
                    type: 'in',
                    field: 'future_active',
                },
            },
            filters: {
                action: {
                    value: 'open',
                    type: 'in',
                    field: 'ac.market_status',
                },
                title: {
                    type: 'in',
                    value: '',
                    field: 'ac.title',
                },
                date_added: {
                    type: 'dategreaterequal',
                    value: '',
                    field: 'ac.date_added',
                },
                date_closed: {
                    type: 'datesmallerequal',
                    value: '',
                    field: 'ac.date_closed',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            getAllAuctions(values)
        },
    })

    useEffect(() => {
        getAllAuctions(formik.values)
    }, [])

    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }
    console.log('---------------->', searchInfo)

    return (
        <>
            <div className="dashboard listing maillisting erpMisc">
                <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                    <Button
                        id="listingDynamic_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            handleRedirectInternal(history, `listing/new/0`)
                        }
                    >
                        <span className="material-icons">add</span>
                        Add single inventory
                    </Button>
                    <Button
                        id="listingDynamic_bulk"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleBulkPopup(true)}
                    >
                        <span className="material-icons-outlined">
                            inventory_2
                        </span>
                        Add bulk inventory
                    </Button>
                    <Button
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => toggleBulkImagePopup(true)}
                    >
                        <span className="material-icons-outlined">
                            collections
                        </span>
                        Add bulk images
                    </Button>
                    <Button
                        id="listingDynamic_report"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${lotStatus}_product_management`,
                            })
                        }
                    >
                        <span className="material-icons-outlined">
                            file_download
                        </span>
                        Export All Data
                    </Button>
                </div>

                <ListingTableView
                    searchInfo={searchInfo}
                    customFilter={custom}
                    tableValue={tableValue}
                    toggleFullScreenPopup={toggleFullScreenPopup}
                    tableActionString={[
                        'open',
                        //'auction_assign',
                        'all_removed',
                    ]}
                    listActionString={['bidcount']}
                    action={lotStatus}
                    dynamicFieldValues={dynamicFieldValues}
                    enableEditTableCell={true}
                    enableColumnEdit={true}
                    auctionList={all_auctions}
                    additionalFilter={true}
                    additionalFilterCallBack={additionalFilterCallBack}
                    additionalFilterCustom={{
                        auctions: props.invId ? props.invId.toString() : '',
                    }}
                    mapArrayData={mapArrayData}
                    propertyColumnReOrder={propertyColumnReOrder}
                    reorderId={'show_order'}
                    showSelectValues={true}
                    reorder={aucId !== '' && aucId !== '0' ? true : false}
                    deleteIcon={true}
                    order={'asc'}
                    auctionAssign_action={['open', 'draft']}
                    orderby={'it.show_order'}
                    barcode={true}
                    qrcode={true}
                    advFilters={true}
                />
            </div>
            {/* <DynamicListing data={manage} function={toggleFullScreenPopup} /> */}
            {/* <DynamicAuctionListing
                data={auctionManage}
                function={toggleAuctionPopup}
            /> */}
            {/* <DynamicBulkListing
                data={bulkPopup}
                function={toggleBulkPopup}
                ignoreFields={[
                    'uploadimages',
                    'wprice',
                    'date_added',
                    'date_closed',
                    'buynow',
                    'bprice',
                    'location_id',
                ]}
            /> */}
            <BulkListing
                data={bulkPopup}
                filterElements={filterElements}
                function={toggleBulkPopup}
                ignoreFields={
                    global?.bulk_ignoreFields ? global.bulk_ignoreFields : []
                }
                // customLocationFilter={{ key: 'user_id', value: user?.id }}
                customDescription={'name'}
                imageUpload={true}
            />
            <DynamicBulkImage
                data={bulkImagePopup}
                function={toggleBulkImagePopup}
                explanationText={`Bulk Image Upload reads the file name of each image and will automatically add to the listings image. The name of the files has to be given in the format of {AuctionField}_{ListingField}-{N}.{ImageFormat} or {AuctionField}_{ListingField} ({N}).{ImageFormat}. <br />  {AuctionField} From Auction Posting: "Auction Cycle" Field has to be given first. <br/> {ListingField} From Listing Posting: "Lot ID" Field has to be given. <br/> {N} Number - Can be any number, as uploading multiple images with same name is not possible, When renaming the number will be automatically added by OS (Mac or Windows). <br /> {ImageFormat} Image Format: Image Format can be .jpg, .png or .webp. <br /> Between the two fields "_" should be given.`}
                separatorFunction={[
                    {
                        symbol: '_',
                        field: 'cac.auction_cycle',
                        table: 'auction',
                        show: 'Auction Cycle',
                    },
                    {
                        symbol: '_',
                        field: 'it.auction_lot',
                        table: 'project',
                        show: 'Lot ID',
                    },
                ]}
                isCompress="true"
            />
        </>
    )
}

export default Inventory
